<template>
  <div class="text-center">
    <img src="~assets/img/logo.png" class="logo" width="192">

    <div class="browser">
        <div class="controls">
          <i></i>
          <i></i>
          <i></i>
        </div>
      
        <div class="eye"></div>
        <div class="eye"></div>
        <div class="mouth">
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
        </div>
    </div>

    <h1>Oops! Página não encontrada...</h1>
    <p>
      Verifique se você digitou o endereço corretamente.
    </p>


  <!-- 404 text -->
  <!--
  <h1>Unfortunately, this page does not exist.</h1>
  <p>The link you clicked may be broken or the page may have been removed.</p>
  -->
  </div>
</template>

<script>
import Fct from 'common/fct'

export default {
  components: {},
  mixins: [Fct],
  data() {
    return {
      url:null
    };
  },

  created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },

  mounted() {
    $(".carregando").hide();
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
  @import "~assets/styles/error.scss";
</style>


// WEBPACK FOOTER //
// 404.vue?bd3df464